export default class Roles {

  public static Admin = 'ADMIN'
  public static Tenant = 'TENANT'
  public static User = 'USER'
  public static Restricted = 'RESTRICTED'
  public static External = 'EXTERNAL'
  public static InnoVivo = 'INNOVIVO'
}
